import { type UserEntity, UserType } from "@/shared/types/user.entity";

/**
 * INTERNAL staff always; a member unless staff switched QR payments off for their organization. A backend
 * that predates the switch omits the field, and QR payments were open to everyone then.
 */
export function canPayBrebQr(user: UserEntity | null | undefined): boolean {
  if (!user) return false;
  return user.user_type === UserType.INTERNAL || user.organization?.breb_qr_payments_enabled !== false;
}
